import React from 'react';
import { ILxsCreateOrderResources } from '../lxs-create-order.props.autogenerated';
import { ISoldToTableData } from '../../../actions/get-sold-tos.action';
import { IShipToTableData } from '../../../actions/get-ship-tos.action';
import { IPostCartItems } from '../../../actions/post-cart.action';
import { useModal } from '../../../components/modal';

export default function processBar({
    step,
    resources,
    products,
    setStep,
    setSoldTo,
    setShipTo,
    pushHistoryState
}: {
    step: number;
    resources: ILxsCreateOrderResources;
    products: IPostCartItems[];
    setStep: React.Dispatch<React.SetStateAction<number>>;
    setSoldTo: (soldTo: ISoldToTableData) => void;
    setShipTo: (shipTo: IShipToTableData) => void;
    pushHistoryState: (currentStep: number) => void;
}) {
    const processBlocked: boolean = step === 6;
    const { setOpen, setClose } = useModal();
    const goTo = (nextStep: number) => {
        if (!processBlocked && nextStep <= Number(step)) {
            pushHistoryState(nextStep);
            setStep(nextStep);
        } else {
            return;
        }
    };

    return (
        <div className='msc-process-bar'>
            <ol className='msc-process-bar__list'>
                <li
                    className={`msc-process-bar__item${step === 1 ? ' msc-process-bar__item--is-active' : ''}`}
                    onClick={() => {
                        if (!processBlocked && step >= 1) {
                            if (products.length > 0) {
                                setOpen({
                                    content: (
                                        <div>
                                            <p className='mb-2'>{resources.createOrderDeleteProductsHint}</p>
                                            <a
                                                className='msc-cta__primary'
                                                onClick={() => {
                                                    setSoldTo({} as ISoldToTableData);
                                                    goTo(1);
                                                    setClose();
                                                }}
                                            >
                                                {resources.createOrderDeleteProductsHintConfirm}
                                            </a>
                                        </div>
                                    ),
                                    size: 'sm'
                                });
                            } else {
                                setSoldTo({} as ISoldToTableData);
                                goTo(1);
                            }
                        }
                    }}
                >
                    <span title={resources.createOrderSoldToSelectionHeading}>{resources.createOrderSoldToSelectionHeading}</span>
                </li>
                <li
                    className={`msc-process-bar__item${step === 2 ? ' msc-process-bar__item--is-active' : ''}`}
                    onClick={() => {
                        if (!processBlocked && step >= 2) {
                            if (products.length > 0) {
                                setOpen({
                                    content: (
                                        <div>
                                            <p className='mb-2'>{resources.createOrderDeleteProductsHint}</p>
                                            <a
                                                className='msc-cta__primary'
                                                onClick={() => {
                                                    setShipTo({} as IShipToTableData);
                                                    goTo(2);
                                                    setClose();
                                                }}
                                            >
                                                {resources.createOrderDeleteProductsHintConfirm}
                                            </a>
                                        </div>
                                    ),
                                    size: 'sm'
                                });
                            } else {
                                setShipTo({} as IShipToTableData);
                                goTo(2);
                            }
                        }
                    }}
                >
                    <span title={resources.createOrderShipToSelectionHeading}>{resources.createOrderShipToSelectionHeading}</span>
                </li>
                <li
                    className={`msc-process-bar__item${step === 3 ? ' msc-process-bar__item--is-active' : ''}`}
                    onClick={() => {
                        if (step >= 3) {
                            goTo(3);
                        }
                    }}
                >
                    <span title={resources.createOrderProductsHeading}>{resources.createOrderProductsHeading}</span>
                </li>
                <li className={`msc-process-bar__item${step === 4 ? ' msc-process-bar__item--is-active' : ''}`} onClick={() => goTo(4)}>
                    <span title={resources.createOrderOrderHeadingInfoHeading}>{resources.createOrderOrderHeadingInfoHeading}</span>
                </li>
                <li className={`msc-process-bar__item${step === 5 ? ' msc-process-bar__item--is-active' : ''}`} onClick={() => goTo(5)}>
                    <span title={resources.createOrderOverviewHeading}>{resources.createOrderOverviewHeading}</span>
                </li>
                <li className={`msc-process-bar__item${step === 6 ? ' msc-process-bar__item--is-active' : ''}`}>
                    <span title={resources.createOrderAcknowledgementHeading}>{resources.createOrderAcknowledgementHeading}</span>
                </li>
            </ol>
        </div>
    );
}
